<!-- Botón para agregar nuevo resultado -->
<div *ngIf="!crearRegistro && !editarRegistro" class="contenedor-boton">
    <button *ngIf="PermisoCrear"
      pButton 
      type="button" 
      icon="pi pi-plus" 
      class="p-button-rounded boton-rosado" 
      pTooltip="Agregar Registro"
      tooltipPosition="top"
      (click)="onCrearRegistro()">
    </button>
    <!-- Botón para descargar resultados en Excel -->
    <button 
      pButton 
      type="button" 
      icon="pi pi-file-excel" 
      class="p-button-rounded boton-rosado" 
      pTooltip="Descargar Excel"
      tooltipPosition="top"
      (click)="descargarExcel()">
    </button>
  </div>

<button *ngIf="crearRegistro || editarRegistro " pButton type="button" icon="pi pi-times" class="p-button-rounded boton-rosado" style="float: right; margin-top: -40px;" (click)="onCancelarEdicion()">
</button>
<!-- Si hayRegistros=false, mostrar el componente app-crearregistro -->
<div *ngIf="crearRegistro || editarRegistro">
    <app-registro [idformulario]="idFormulario" [idencuesta]="idEncuesta" [idsujeto]="idRegistro" (RegistroGuardado)="onRegistroGuardado()" ></app-registro>
</div>

<div *ngIf="!hayRegistros && !editarRegistro && !crearRegistro">
    <h2>No hay registros</h2>
</div>


<div *ngIf="hayRegistros && !editarRegistro && !crearRegistro"> 
    <p-multiSelect 
    [options]="opciones" 
    [(ngModel)]="columnasSeleccionadas"
    optionLabel="label"
    selectedItemsLabel="{0} columnasSeleccionadas"
    defaultLabel="Seleccionar columnas"
    > <!-- Deshabilita el campo de búsqueda -->
    </p-multiSelect>
    <!-- Boton filtrar -->
    <button mat-raised-button (click)="filtrar()">Filtrar</button>


<!-- Valores cuando estaba tipo lazy (se solicitaba cada pagina a la api)
    [value]="registros" 
    [tableStyle]="{ 'min-width': '50rem' }" 
    [rowHover]="true"
    [paginator]="true" 
    [globalFilterFields]="['Correo', 'Nombres']"
    [rows]="tampag"
    [lazy]="true"
    [totalRecords]="total"
    [(first)]="saltar"
    (onPage)="cambiarPagina($event)"
    (onLazyLoad)="cambiarPagina($event)" 
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10,50,100,500]"> -->



    <p-table #dt
        [value]="registros" 
        [tableStyle]="{ 'min-width': '50rem' }" 
        [rowHover]="true"
        [paginator]="true" 
        [globalFilterFields]="['Correo', 'Nombres']"
        [rows]="tampag"
        [showCurrentPageReport]="true"
        [rowsPerPageOptions]="[10,50,100,500]"
        [globalFilterFields]="columnas"
        filterDisplay="menu"
        scrollable="true" 
        scrollHeight="600px">

         

    <ng-template pTemplate="header">
        <tr>
            <th *ngFor="let columna of columnas" >
                <span
                pSortableColumn="{{ columna }}"
                class="header-label">
                {{ columna }}
                <p-sortIcon [field]="columna"></p-sortIcon>
                </span>
                <p-columnFilter type="text"  field="{{columna}}" matchMode="contains" [showMenu]="false" >
                    
                </p-columnFilter>
            </th>
            <th>Opciones</th> 
        </tr>
    </ng-template>

    <ng-template pTemplate="body" let-registro>
        <tr (click)="navigateToRegistro(registro._id)" pSelectableRow>
            <td *ngFor="let columna of columnas">{{ registro[columna] }}</td>
            <td>
                <!-- Botón Ver Programas (solo si es Patrocinadores) -->
                <!-- ID encuesta Patrocinadores: 692e0e3650e0fc117615ae31 -->
                <button *ngIf="idEncuesta === '692e0e3650e0fc117615ae31'"
                        pButton pRipple type="button" label="Programas"
                        class="p-button-rounded p-button-text p-button-info"
                        title="Ver Programas"
                        (click)="navigateToProgramas(registro.patCodigo); $event.stopPropagation()">
                </button>

                <!-- Botón Ver Promociones (solo si es Programas) -->
                <!-- ID encuesta Programas: 692e3c68b275b4b3bf746eea -->
                <button *ngIf="idEncuesta === '692e3c68b275b4b3bf746eea'"
                        pButton pRipple type="button" label="Promociones"
                        class="p-button-rounded p-button-text p-button-success"
                        title="Ver Promociones"
                        (click)="navigateToPromociones(registro.pliPatrocinador_patCodigo, registro.progCodigo); $event.stopPropagation()">
                </button>

                <!-- Botón Ver Formulario (solo si es Promociones) -->
                <!-- ID encuesta Promociones: 692ececcb899a66ff14b8d66 -->
                <button *ngIf="idEncuesta === '692ececcb899a66ff14b8d66'"
                        pButton pRipple type="button" label="Formulario"
                        class="p-button-rounded p-button-text p-button-help"
                        title="Ver Formulario de la promoción"
                        (click)="navigateToFormularioPromocion(registro.promCodigo, registro.progCodigo, registro.pliPatrocinador_patCodigo); $event.stopPropagation()">
                </button>

                <button *ngIf="PermisoEditar" pButton pRipple type="button" icon="pi pi-pencil" 
                        class="p-button-rounded p-button-text p-button-warning"
                        title="Editar Registro"
                        (click)="navigateToEditarRegistro(registro._id); $event.stopPropagation()">
                </button>

                <button *ngIf="PermisoEliminar" pButton pRipple type="button" icon="pi pi-trash"
                        class="p-button-rounded p-button-text p-button-danger"
                        title="Eliminar Registro"
                        (click)="eliminarRegistro(registro._id); $event.stopPropagation()">
                </button>
            </td>
        </tr>
    </ng-template>

    <ng-template pTemplate="summary">
        <div class="p-d-flex p-ai-center p-jc-between">
          Total Registros : {{total}}
        </div>
    </ng-template>

</p-table>
</div>

<div *ngIf="editarRegistro">
    <!-- <app-editarregistro [IdRegistro]="idRegistro" [Registro]="Registro" (edicionFinalizada)="onEdicionFinalizada()"></app-editarregistro> -->
</div>

